import React, { useState, useRef, useEffect, useCallback } from "react";
import PlanActualsGrid from "./Grids/PlanActualsGridOne";
// import courseData from './mockData.json';
import ReportsFilter from "./ReportsFilter";
// import Year from '../Calendar/Year';

const Trainers = () => {
    const [selectedYear, setSelectedYear] = useState();
    const [selectedCustomerCodeInfo, setSelectedCustomerCodeInfo] = useState("Customer Code");

    const handleCustomerCodeChange = (custCode) => {
        setSelectedCustomerCodeInfo(custCode);
    }

    const handleYearChange = (year) => {
        setSelectedYear(year);
    }

    const handleAddTraining = () => {
        setShowTrainingForm(true);
    }

    return (
        <>
            <div className="w-full sm:w-12/12 px-28 py-8">
                <ReportsFilter handleAddTraining={handleAddTraining} handleYearChange={handleYearChange} hideForecastButton={true} hideAddButton={false} handleCustomerCodeChange={handleCustomerCodeChange} />
            </div>
            <div className="grid grid-cols-1 gap-16 px-24 pb-8">
                <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#8B6392", textAlign:"center" }}>
                    <h4>TRAINERS(PLAN VS ACTUALS) - YEARLY REPORTS</h4>
                    <PlanActualsGrid />
                </div>
            </div>
            {/* <div style={{ borderTop: "1px solid #FFFFFF", margin: "20px 20px" }}></div> */}
        </>
    )
}

export default Trainers;